/* tslint:disable */

/**
 */
export class CalculationParametersDefSave {
    isStudyAlphaRightFixedDef?: number;
    ishorizScanDef?: number;
    maxIter?: number;
    relaxCoef?: number;
    precision?: number;
    stopTopSurfDef?: number;
    stopIntDef?: number;
    stopBottomSurfDef?: number;
    stopAvgDef?: number;
    isStudyAlphaTopFixedDef?: number;
    isStudyAlphaBottomFixedDef?: number;
    isStudyAlphaLeftFixedDef?: number;
    isVertScanDef?: number;
    isStudyAlphaFrontFixedDef?: number;
    isStudyAlphaRearFixedDef?: number;
    studyAlphaTopDef?: number;
    studyAlphaBottomDef?: number;
    studyAlphaLeftDef?: number;
    studyAlphaRightDef?: number;
    studyAlphaFrontDef?: number;
    studyAlphaRearDef?: number;
    storageStepDef?: number;
    precisionLogStepDef?: number;
    timeStepDef?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/calculation-parameters-def-save.ts